import React from 'react';
import { useBootstrapState } from '../bootstrap/bootstrap-provider';
import { EnabledFeaturesProvider as CoreEnabledFeaturesProvider } from '../common/hooks/enabled-features/enabled-features-provider';
import { useEnabledFeaturesBroadcast } from './use-enabled-features-broadcast';

export function EnabledFeaturesProvider(props: {
    children: React.ReactElement;
}): React.ReactElement {
    const enabledFeaturesBroadcast = useEnabledFeaturesBroadcast();
    const bootstrapState = useBootstrapState();

    return (
        <CoreEnabledFeaturesProvider
            enabledFeaturesBroadcast={enabledFeaturesBroadcast}
            // @ts-expect-error enabledFeatures is not on the type returned by useBootstrapState
            // but is there at runtime
            enabledFeaturesBootstrap={bootstrapState.enabledFeatures}
        >
            {props.children}
        </CoreEnabledFeaturesProvider>
    );
}
